module.exports = __webpack_public_path__ + "static/media/record-nav-left-inactive.39f31656.svg";